"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 1,
  y: 17,
  fill: "var(--sds--ursa-icons--selected-color, currentColor)",
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m14.637 9.356-.514.474-.515-.474a.7.7 0 0 1 1.03 0m-.514 1.578-.117.161c-.16.226-.308.464-.414.685-.113.234-.146.387-.146.46 0 .37.306.677.677.677.37 0 .677-.306.677-.678 0-.073-.034-.225-.146-.46a5 5 0 0 0-.415-.684zm1.793.24c.145.303.284.68.284 1.065a2.08 2.08 0 0 1-2.077 2.078 2.08 2.08 0 0 1-2.077-2.077c0-.385.138-.762.284-1.066.152-.317.348-.624.532-.886a10 10 0 0 1 .726-.91l.014-.016.004-.004.002-.002.515.474.514-.474.002.002.005.004.014.016a6 6 0 0 1 .217.25c.137.165.322.396.508.66.185.261.38.57.533.886M7.365 2.512a.7.7 0 0 1 .99-.014l.831.809 3.22 3.22a2.65 2.65 0 0 1 0 3.75l-1.84 1.84a2.65 2.65 0 0 1-3.75 0l-1.84-1.84a2.65 2.65 0 0 1 0-3.75l2.718-2.718-.316-.307a.7.7 0 0 1-.013-.99m1.326 2.28L5.966 7.517q-.141.143-.228.312l5.909.005a1.3 1.3 0 0 0-.231-.317zm2.775 4.442-5.553-.005q.026.03.053.057l1.84 1.84a1.25 1.25 0 0 0 1.77 0l1.84-1.84z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BackgroundColorWithSelectionIcon20.js.map